<template class="full-height">
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="coupon-app-container" style="position: relative; height: 100%; padding: 15px">
    <el-dialog
      v-if="travelFormData"
      v-loading="listLoading"
      append-to-body
      modal-append-to-body
      @opened="getTravelForms"
      :title="`${travelFormData.travelName} - 旅遊團表單維護`"
      :visible.sync="dialogTravelFormVisible"
      width="30%"
    >
      <el-form ref="travelFormData" :model="travelFormData" label-width="120px">
        <el-form-item label="旅遊團名稱">
          <el-tag>{{ travelFormData.travelName }}</el-tag>
        </el-form-item>

        <el-form-item label="表單">
          <div>
            <el-row>
              <el-col :span="20">
                <div>
                  <Upload
                    ref="uploadRefTravel"
                    :accept="'.pdf'"
                    :payload="travelFormData"
                    :data-obj="travelFileObj"
                    :limitText="'檔案須為.pdf格式，限制不超過2000MB'"
                    :limit-file-count="20"
                    :use-drag="false"
                    :action="'TravelSettings/commonFormsForTravel'"
                    :auto-upload="false"
                    :show-file-list="true"
                    :form-on-loading-parent="formLoading"
                    :btn-txt="'上傳旅遊團專用表單'"
                    :before-file-list="
                      travelFormData.commonForms && travelFormData.commonForms.length
                        ? travelFormData.commonForms[0].files
                        : []
                    "
                  />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="warning" @click="saveTravelData"> 儲 存 </el-button>
        <el-button size="mini" @click="dialogTravelFormVisible = false" type="danger"
          >關 閉</el-button
        >
      </span>
    </el-dialog>

    <el-tabs type="border-card" v-model="tabPosition" style="height: 100%">
      <el-tab-pane name="tab3" label="分房表">
        <agencyTravelersRoomHistory />
      </el-tab-pane>
      <el-tab-pane name="tab2" label="回傳表單">
        <result-forms></result-forms>
      </el-tab-pane>
      <el-tab-pane name="tab1" label="表單管理">
        <el-row>
          <el-card class="box-card" v-loading="formLoading" style="padding: 10px; height: 100%">
            <div slot="header" class="clearfix">
              <el-alert
                title="旅遊團常用表單上傳(最多一次同時上傳20個檔案)，將顯示在領隊APP，表單的功能中。"
                type="warning"
                effect="dark"
                :closable="false"
                style="color: #4b4b4b"
              ></el-alert>
            </div>
            <div>
              <el-row>
                <el-col :span="20">
                  <div>
                    <Upload
                      ref="uploadRef"
                      :accept="'.pdf'"
                      :payload="formData"
                      :data-obj="fileObj"
                      :limitText="'檔案須為.pdf格式，限制不超過2000MB'"
                      :limit-file-count="20"
                      :use-drag="false"
                      :action="'TravelSettings/saveGroupTourCommonForms'"
                      :auto-upload="false"
                      :show-file-list="true"
                      :form-on-loading-parent="formLoading"
                      :btn-txt="'上傳所有旅行團通用表單'"
                      :before-file-list="
                        formData.commonForms && formData.commonForms.length
                          ? formData.commonForms[0].files
                          : []
                      "
                    />
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin-top: 10px">
                <el-button type="warning" @click="saveData" style="color: #4b4b4b">
                  儲 存
                </el-button>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <hr />
        <el-row style="position: relative; height: 100%">
          <el-col :span="5" style="position: relative; height: 100%">
            <el-form :inline="true" class="filter-form">
              <el-form-item label="團號">
                <el-input v-model="listQuery.qry" placeholder="輸入團號" />
              </el-form-item>

              <el-form-item label="團名">
                <el-input v-model="listQuery.qrySecond" placeholder="輸入團名" />
              </el-form-item>

              <el-button
                type="primary"
                @click="getTravels"
                icon="el-icon-search"
                circle
                style="margin-top: 8px; margin-left: 5px"
                :disabled="listLoading"
              ></el-button>

              <el-button
                style="cursor: pointer"
                type="success"
                :loading="listLoading"
                circle
                icon="el-icon-refresh-left"
                @click="refresh()"
              ></el-button>
            </el-form>
          </el-col>

          <el-col :span="18" style="position: relative; height: 100%" :offset="1">
            <div style="position: relative; height: 46%">
              <el-table
                v-loading="listLoading"
                size="mini"
                :data="list"
                border
                fit
                highlight-current-row
                style="width: 100%"
                height="90%"
              >
                <el-table-column align="center" label="項次" width="60" fixed="left">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  align="center"
                  label="團號"
                  width="160"
                  fixed="left"
                  :fixed="device !== 'mobile' ? 'left' : null"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.tourGroupNo }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  align="left"
                  label="團名"
                  width="200"
                  fixed="left"
                  :fixed="device !== 'mobile' ? 'left' : null"
                >
                  <template slot-scope="{ row }">
                    <span>{{ row.travelName }}</span>
                    <div></div>
                  </template>
                </el-table-column>

                <el-table-column align="center" label="出發" width="200">
                  <template slot-scope="{ row }">
                    <div>
                      <el-tag
                        ><span style="color: green">{{
                          `${row.beginDate}
                          ${row.beginTime}`
                        }}</span>
                      </el-tag>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column align="center" label="回程" width="200">
                  <template slot-scope="{ row }">
                    <div>
                      <el-tag
                        ><span style="color: red">{{
                          `${row.endDate}
                          ${row.endTime}`
                        }}</span>
                      </el-tag>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column align="center" label="指定當團表單" width="200">
                  <template slot-scope="{ row }">
                    <el-button size="mini" type="primary" @click="editTravelForm(row)" plain
                      >表單維護</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <pagination
              v-show="total > 0"
              layout="prev, pager, next"
              :total="total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              @pagination="getTravels"
            />
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getCommonForms, saveCommonForms, getCommonTravelFormList } from '@/api/travel'
import { MessageBox, Message } from 'element-ui'
import { mapGetters } from 'vuex'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination

export default {
  name: 'CommonForms',
  components: {
    Upload: () => import('@/views/ita/components/fileUpload.vue'),
    agencyTravelersRoomHistory: () =>
      import('@/views/ita/agency/agencyTravelersRoomHistory/index.vue'),
    ResultForms: () => import('@/views/ita/agency/agencyResultForms/index.vue'),
    Pagination,
  },
  computed: {
    ...mapGetters(['userInfo', 'device', 'showDownloadLoading']),
  },
  data() {
    return {
      dialogTravelFormVisible: false,
      tabPosition: 'tab3',
      list: null,
      fileObj: { id: 0, type: 'tourInfo', user: '' },
      travelFileObj: { id: 0, type: 'tourInfo', user: '' },
      formLoading: false,
      formData: { commonForms: [] },
      travelFormData: { travelId: null, commonForms: [] },
      listLoading: false,
      listQuery: {
        dates: null,
        travelProperty: null,
        memberCount: 0,
        countryArea: [],
        dateFilter: [],
        memberQry: '',
        qry: '',
        qrySecond: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-beginDate',
        agencyCode: null,
      },
      total: 0,
      list: [],
    }
  },
  async created() {
    this.getForms()
    await this.getTravels()
  },
  methods: {
    defaultListyQuerySetting() {
      this.listQuery.travelProperty = null
      this.listQuery.memberCount = 50
      this.listQuery.countryArea = []
      this.listQuery.dateFilter = []
      this.listQuery.qry = ''
      this.listQuery.qrySecond = ''
      this.listQuery.date = ''
      this.listQuery.status = null
      this.listQuery.page = 1
      this.listQuery.limit = 20
      this.listQuery.sort = '-beginDate'
    },
    async refresh() {
      this.defaultListyQuerySetting()
      await this.getTravels()
    },
    async editTravelForm(row) {
      this.travelFormData = row
      this.dialogTravelFormVisible = true
    },
    async getForms() {
      let vm = this

      let resp = await getCommonForms()
      vm.formData.commonForms = resp.data
    },
    async getTravelForms() {
      let vm = this
      let refUpload = this.$refs['uploadRefTravel']
      refUpload.clearFiles()
      let resp = await getCommonForms({ travelId: vm.travelFormData.id })
      vm.travelFormData.commonForms = resp.data
    },
    async getTravels() {
      const vm = this
      vm.listLoading = true
      await getCommonTravelFormList(vm.listQuery).then(response => {
        debugger
        vm.list = response.data.data
        vm.total = response.data.total
        vm.listLoading = false
      })
    },
    async getTravels() {
      const vm = this
      vm.listLoading = true
      await getCommonTravelFormList(vm.listQuery).then(response => {
        debugger
        vm.list = response.data.data
        vm.total = response.data.total
        vm.listLoading = false
      })
    },
    async saveData(formName) {
      const vm = this
      if (!confirm(`確定要儲存資料?`)) {
        return false
      }
      let refUpload = this.$refs['uploadRef']

      vm.formLoading = true
      let payload = await refUpload.combineFileAndPayload()
      console.log('payload')
      console.log(payload)
      if (!payload) {
        alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
        return false
      }

      try {
        let res = await saveCommonForms(payload)
        refUpload.clearFiles()
        vm.formLoading = false
        vm.getForms()
        Message({
          message: '資料處理完成',
          type: 'success',
          duration: 5 * 1000,
        })
      } catch (error) {
        vm.formLoading = false
      }
    },
    async saveTravelData() {
      const vm = this
      if (!confirm(`確定要儲存旅遊團表單資料?`)) {
        return false
      }
      let refUpload = this.$refs['uploadRefTravel']

      vm.formLoading = true
      let payload = await refUpload.combineFileAndPayload()
      if (!payload) {
        alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
        return false
      }

      payload.travelId = payload.id

      try {
        let res = await saveCommonForms(payload)
        refUpload.clearFiles()
        vm.formLoading = false
        vm.dialogTravelFormVisible = false
        vm.getTravelForms()
        Message({
          message: '資料處理完成',
          type: 'success',
          duration: 5 * 1000,
        })
      } catch (error) {
        vm.formLoading = false
      }
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}
</style>
